<form [formGroup]="form" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="button" [disabled]="!exportIsAvailable()" title="Exportar" class="btn btn-outline-success" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Exportando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>Informe General de Tasas de Exportación</h4>

        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
        <div class="row">
            <div class="col-md-12">


                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i>
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapsedFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group  col-xl-2 col-md-4">
                                    <label class="col-form-label" for="inpFecha">Fecha Desde</label>
                                    <p-calendar formControlName="FechaDesde" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-xl-2 col-md-4">
                                    <label class="col-form-label" for="inpFecha">Fecha Hasta</label>
                                    <p-calendar formControlName="FechaHasta" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-xl-4 col-md-4">
                                    <label class="col-form-label" for="inpProvincia">Provincia</label>
                                    <ng-select [items]="listProvincias"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvincia"
                                               loadingText="Cargando..."
                                               [readonly]="!listProvincias || listProvincias.length === 0"
                                               [loading]="loadingProvincias"
                                               notFoundText="Provincia no encontrada"
                                               placeholder="-- Seleccione una Provincia --"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectProvincia($event)">
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-4 col-md-4">
                                    <label class="col-form-label" for="inpTipo">Punto de Inspección</label>

                                    <ng-select #municipio loadingText="Cargando..."
                                               [items]="listPuntosInspeccion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPuntoInspeccion"
                                               [readonly]="!listPuntosInspeccion || listPuntosInspeccion.length === 0"
                                               [loading]="loadingPIFs && form.value.IdProvincia > 0"
                                               notFoundText="Punto de Inspección no encontrado"
                                               placeholder="-- Seleccione un Punto de Inspección --"
                                               [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')"
                                               clearAllText="Eliminar selección"
                                               (change)="onSelectPuntoInspeccion($event)">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-4 col-md-4">
                                    <label class="col-form-label" for="inpRazonSocial">Solicitante</label>
                                    <input formControlName="RazonSocial" name="RazonSocial" title="" class="form-control" id="inpRazonSocial" type="text" value="" maxlength="255">
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div *ngIf="isCollapsed" class="form-group-0 float-left ui-fontgris">
                                    Pulse sobre "<i class="fa fa-caret-down"></i>" para desplegar los criterios de búsqueda
                                </div>
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="button" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" [disabled]="formIsUntouched" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!--DATAGRID-->
        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Informe de Tasas
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultInformeTasas?.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                 [columns]="cols" [rows]="resultInformeTasas?.PageSize"
                                 [totalRecords]="resultInformeTasas?.TotalCount" [loading]="loading"
                                 [ngClass]="displayGridHidden(resultInformeTasas?.ResultList)"
                                 styleClass="table table-responsive-sm  table-striped table-sm">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th nowrap scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link' && col.field!=='Image'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">

                                <tr>
                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">

                                        <span *ngIf="(col.field!=='Link' && col.field!=='Image' && col.field!=='FechaSolicitud' &&
                                                      col.field!=='FechaLiquidacion' && col.field!=='TotalTasas')">
                                            {{rowData[col.field]}}
                                        </span>
                                        <span *ngIf="col.field==='TotalTasas'">{{rowData[col.field] | number:'1.2-2':'es'}}</span>
                                        <span *ngIf="col.field==='FechaSolicitud' || col.field==='FechaLiquidacion'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                        <span *ngIf="col.field==='Image'">
                                            <!--***ICONOS***-->
                                            <img class="estado-icono" src="{{ null | IconoEstadoSolicitud}}" container="body" ngbTooltip="{{rowData['NombreTipoSolicitudComplete']}}" />
                                            <label class="codigo-icono" container="body" ngbTooltip="{{rowData['NombreTipoSolicitudExComplete']}}">{{rowData['CodigoTipoSolicitudEx']}}</label>
                                            <img class="estado-icono" src="{{rowData['IdEstadoSolicitudEx'] | IconoEstadoSolicitudEx}}" container="body" ngbTooltip="{{rowData['EstadoSolicitudEx']}}" />
                                            <img class="predua-icono" src="{{rowData['IsPredua'] | IconoPreduaSolicitud}}" container="body" ngbTooltip="{{rowData['IsPredua'] | preduaNoPredua}}" />
                                        </span>

                                    </td>
                                </tr>

                            </ng-template>

                        </p-table>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
